"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.layout = void 0;
const foundation_1 = require("../foundation");
exports.layout = {
    gutter: {
        ids_layout_gutter_xs: foundation_1.foundation_size.small.size_small_16,
        ids_layout_gutter_sm: foundation_1.foundation_size.small.size_small_16,
        ids_layout_gutter_md: foundation_1.foundation_size.medium.size_medium_32,
        ids_layout_gutter_lg: foundation_1.foundation_size.medium.size_medium_32,
        ids_layout_gutter_xl: foundation_1.foundation_size.medium.size_medium_32,
    },
    padding: {
        ids_layout_padding_xs: foundation_1.foundation_size.small.size_small_24,
        ids_layout_padding_sm: foundation_1.foundation_size.small.size_small_24,
        ids_layout_padding_md: foundation_1.foundation_size.medium.size_medium_48,
        ids_layout_padding_lg: foundation_1.foundation_size.medium.size_medium_56,
        ids_layout_padding_xl: foundation_1.foundation_size.large.size_large_72,
    },
};
//# sourceMappingURL=layout.js.map